<template>
    <div v-if="loading" class="loading-box">
        <b-spinner></b-spinner>
    </div>
    <div v-else>
        <div id="account-discount" v-if="user">
        <div class="box-shadow mb-20" v-if="(user.card.type == 'Физическое лицо' && user.card.series_number_passport && user.card.series_number_passport != '-') || (user.card.type == 'Юридическое лицо' && user.card.full_name && user.card.full_name != '-')">
            <div class="discount-card">
                <div class="h5 mb-1">
                    НАКОПЛЕННЫЕ БАЛЛЫ:
                    <span v-if="!user.userData.old_discount || user.discount_program.bonuses !== 0 && user.userData.start_bonuses !== 0" class="color-text-red"> {{user.discount_program.bonuses}}</span>
                    <span v-else class="color-text-red"> 0 </span>
                </div>
                <div class="h5 mb-1">Скидка:
                    <span class="color-text-red" v-if="user.discount_program.discount_program !== 0"> {{user.discount_program.discount_program}}%</span>
                    <span v-else> 0%</span>
                </div>
            </div>
        </div>

        <div class="box-shadow mb-20" v-else>
            <div class="h5 mb-0">Для того, чтобы получить персональную скидку на всю продукцию MRental, пройдите полную регистрацию, заполнив личные данные
                в разделе
                <router-link to="/account/card" class="color-primary">"Карта клиента".</router-link>
            </div>
        </div>

        <div v-if="user.userOrders && user.userOrders.length > 0" class="box-shadow mb-20">
            <div class="history-card">
                <div class="title-3 mb-20 color-primary">История</div>
                <div class="history-card__header">
                    <div class="h6">Дата</div>
                    <div class="h6">Стоимость заказа</div>
                </div>
                <div v-for="item in user.userOrders" class="history-card__item">
                    <div class="h5">{{getDate(item.booked_from)}}</div>
                    <div class="h5">{{item.final_price}} RUB</div>
                </div>
            </div>
        </div>

        <div v-if="user.discount_program.info" class="box-shadow">
            <div v-html="user.discount_program.info"></div>
        </div>

    </div>
    </div>
</template>

<script>
    import order from "../../../../services/order";

    export default {
        data() {
            return {
                order: order,
                loading: true
            }
        },

        computed: {
            user() {
                return this.$store.getters.getUser;
            },
        },

        mounted() {
            this.$store.dispatch('fetchUser');

            setTimeout(() => {
                this.loading = false;
            }, 1500)

        },

        methods: {
            getDate(date) {
                return this.order.echoDate(date)
            }
        }
    }
</script>
